import config from '../config/config';

/** Таймауты согласованы с RyaskovProServer appsettings SignalR (ClientTimeout ≈ 120s). */
export const SIGNALR_SERVER_TIMEOUT_MS = 150_000;
export const SIGNALR_KEEP_ALIVE_MS = 30_000;
export const SIGNALR_RECONNECT_DELAYS_MS = [0, 2_000, 5_000, 10_000, 30_000];

export function getSignalRAccessToken(): string {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(config.auth.tokenKey) ?? '';
}

export function setupSignalRVisibilityReconnect(reconnect: () => void): () => void {
  if (typeof document === 'undefined') return () => {};

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      reconnect();
    }
  };

  document.addEventListener('visibilitychange', onVisibilityChange);
  return () => document.removeEventListener('visibilitychange', onVisibilityChange);
}
